<template>
    <v-container fluid style="margin-top: 60px;margin-bottom:10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.PorQueRegistrarse') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row align="center" style="background:#4180FF;margin-top:3%;padding: 5% 5%;">
            <v-col cols="12" sm="12" md="6" class="px-5">
                <h1 class="mb-5 pb-5 secondary--text" :style="textoInicio">{{ $t('Menu.PorQueRegistrarse').toUpperCase() }}</h1>
            </v-col>
            <v-col v-if="pqr" cols="12" sm="12" md="6" style="padding: 0 5%">
              <div class="textoMagazine pqr" v-html="pqr.descripcionEs" v-if="getIdioma === 'es'" />
              <div class="textoMagazine pqr" v-html="pqr.descripcionEn" v-else />
            </v-col>
            <v-col cols="12" align="center" style="margin-top:100px;">
                <v-btn @click="dialog = true" style="min-width:15%!important" class="white--text" x-large color="black">{{ $t('Menu.Postulate') }}</v-btn>
              </v-col>
            <v-dialog v-model="dialog" style="max-width:90%" content-class="registrarse">
                <v-form v-model="valido">
                    <v-card>
                        <v-card-text>
                            <v-row style="background:white;padding: 5% 10%;">
                              <v-form style="width:100%" v-model="valido">
                                <v-col cols="12" align="center">
                                  <h1 class="vietnam black--text display-2 mb-5 pb-5">{{$t('Formularios.Bienvenido')}}</h1>
                                </v-col>
                                <v-col cols="12" xs="12">
                                  <v-text-field solo :rules="requerido.nombre" v-model="info.nombre" :label="$t('Formularios.NombreCompleto')" :hint="$t('Formularios.NombreCompleto')" required persistent-hint />
                                </v-col>
                                <v-col cols="12" xs="12">
                                  <v-text-field solo :rules="requerido.pseudonimo" v-model="info.pseudonimo" :label="$t('Formularios.Pseudonimo')" :hint="$t('Formularios.Pseudonimo')" required persistent-hint />
                                </v-col>
                                <v-col cols="12" xs="12">
                                  <v-text-field solo :rules="requerido.email" v-model="info.email" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" required persistent-hint />
                                </v-col>
                                <v-col cols="12" xs="12">
                                  <v-text-field solo :rules="requerido.telefono" v-model="info.telefono" :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')" required persistent-hint />
                                </v-col>
                                <v-col cols="12" xs="12">
                                  <v-autocomplete solo :rules="requerido.pais" :items="getPaises" item-text="name" item-value="id" v-model="info.pais" :label="$t('Formularios.Pais')" :hint="$t('Formularios.Pais')" persistent-hint />
                                </v-col>
                                <v-col cols="12" xs="12" v-if="info.pais">
                                  <v-autocomplete solo :rules="requerido.departamento" :items="Object.keys(getPaises[info.pais - 1].states)" v-model="info.departamento" :label="$t('Formularios.Departamento')" :hint="$t('Formularios.Departamento')" persistent-hint />
                                </v-col>
                                <v-col cols="12" xs="12" v-if="info.departamento">
                                  <v-text-field class="mx-2" solo persistent-hint v-model="info.ciudad" :label="$t('Formularios.Ciudad')" :hint="$t('Formularios.Ciudad')" />
                                </v-col>
                                <v-col cols="12" xs="12">
                                    <v-select solo :rules="requerido.categoria" :items="tipoArtista" item-text="nombre" item-value="id" v-model="info.categoria" :label="$t('Formularios.Categoria')" :hint="$t('Formularios.Categoria')" persistent-hint />
                                </v-col>
                                <v-col cols="12">
                                  <v-textarea solo :rules="requerido.biografia" v-model="info.biografiaEs" :label="$t('Formularios.Biografia')" :hint="$t('Formularios.Biografia')" counter="300" persistent-hint />
                                  <v-divider />
                                </v-col>
                                <v-col cols="12" xs="12">
                                  <v-textarea solo :rules="requerido.vision" v-model="info.vision" :label="$t('Formularios.Vision')" :hint="$t('Formularios.Vision')" required persistent-hint counter="500"/>
                                </v-col>
                                <v-col cols="12" xs="12">
                                  <v-textarea solo :rules="requerido.camino" v-model="info.camino" :label="$t('Formularios.Camino')" :hint="$t('Formularios.Camino')" required persistent-hint counter="500"/>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                  <v-switch solo v-model="incluirRed" :label="$t('Formularios.IncluirRedSocial')" @change="cambioIncluirRed" color="error" style="word-break:break-word;" />
                                </v-col>

                                <div v-if="incluirRed">
                                  <v-col cols="12" xs="12">
                                    <v-autocomplete solo :items="getTipoRedes" item-text="nombre" item-value="icono" v-model="iconoRed" :label="$t('Formularios.RedSocial')" :hint="$t('Formularios.RedSocial')" persistent-hint />
                                  </v-col>
                                  <v-col cols="12" xs="12">
                                    <v-text-field solo v-model="enlaceRed" :label="$t('Formularios.EnlaceRedSocial')" :hint="$t('Formularios.EnlaceRedSocial')" v-on:keyup.enter="anadirRed" persistent-hint />
                                  </v-col>
                                  <v-col cols="12" align="center">
                                    <v-btn color="black white--text" :disabled="iconoRed == null || enlaceRed == null" @click="anadirRed">{{ $t('Formularios.AnadirRedSocial') }}</v-btn>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-simple-table>
                                      <thead>
                                      <tr>
                                        <th class="text-center">{{ $t('Formularios.Red') }}</th>
                                        <th class="text-center">{{ $t('Formularios.Enlace') }}</th>
                                        <th class="text-center">{{ $t('Formularios.Eliminar') }}</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(i, index) in info.redesSociales" :key="i.enlace">
                                          <td class="text-center"><v-icon>{{i.icono}}</v-icon></td>
                                          <td class="text-center">{{i.enlace}}</td>
                                          <td class="text-center"><v-btn text small @click="eliminarRed(index)"><v-icon>fas fa-times</v-icon></v-btn></td>
                                        </tr>
                                      </tbody>
                                    </v-simple-table>
                                  </v-col>
                                </div>
                                <v-col cols="12">
                                  <v-file-input v-model="preImagenes" @change="moverImagen()" :label="$t('Formularios.AdjuntaImagenes')" :hint="$t('Formularios.AdjuntaImagenes')" persistent-hint solo multiple accept="image/*"/>
                                </v-col>
                                <v-col cols="12">
                                  <v-chip v-for="(i, index) in imagenes" :key="i.name" close @click:close="removerImagen(index)" color="primary white--text">{{i.name}}</v-chip>
                                </v-col>
                                <v-col cols="12" align="center">
                                    <v-btn class="ma-3" style="border: 2px solid;" @click="dialog = false" outlined x-large color="black">{{ $t('Formularios.Cerrar')}}</v-btn>
                                    <v-btn class="ma-3" :disabled="!valido || imagenes.length <3 || (incluirRed && info.redesSociales.length <1)" @click="usuarios"  style="min-width:20%!important" color="primary white--text" x-large :loading="getCargandoAccion">{{ $t('Formularios.Postulate')}}</v-btn>
                                </v-col>
                              </v-form>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as faker from 'faker'
import firebase from '@/plugins/firebase'
import 'firebase/firestore'
export default {
  name: 'PorQueRegistrarse',
  data () {
    return {
      artistas: [],
      pqr: null,
      dialog: false,
      valido: false,
      requerido: {
        nombre: [v => !!v || this.$i18n.t('Formularios.NombreRequerido')],
        pseudonimo: [v => !!v || this.$i18n.t('Formularios.PseudonimoRequerido')],
        email: [v => !!v || this.$i18n.t('Formularios.EmailRequerido')],
        telefono: [v => !!v || this.$i18n.t('Formularios.TelefonoRequerido')],
        pais: [v => !!v || this.$i18n.t('Formularios.PaisRequerido')],
        departamento: [v => !!v || this.$i18n.t('Formularios.DepartamentoRequerido')],
        ciudad: [v => !!v || this.$i18n.t('Formularios.CiudadRequerido')],
        categoria: [v => !!v || this.$i18n.t('Formularios.CategoriaRequerido')],
        biografia: [v => !!v || this.$i18n.t('Formularios.BiografiaRequerido')],
        vision: [v => !!v || this.$i18n.t('Formularios.Vision')],
        camino: [v => !!v || this.$i18n.t('Formularios.Camino')]
      },
      imagenRequerida: [v => v[0] || 'Imagen Requerida'],
      info: {
        nombre: null,
        pseudonimo: null,
        email: null,
        telefono: null,
        pais: null,
        departamento: null,
        ciudad: null,
        direccion: null,
        redesSociales: [],
        imagenes: [],
        codigo: faker.random.alphaNumeric(8).toUpperCase(),
        aprobado: false,
        categoria: null,
        biografiaEs: null,
        revisado: false,
        idioma: null,
        vision: null,
        camino: null
      },
      incluirRed: false,
      iconoRed: null,
      enlaceRed: null,
      preImagenes: [],
      imagenes: [],
      tipoArtista: [
        {
          id: 'artista',
          nombre: this.$i18n.t('Formularios.Artista')
        },
        {
          id: 'disenador',
          nombre: this.$i18n.t('Formularios.Disenador')
        }
      ]
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('pqr').get().then(info => {
      this.pqr = info.data()
    })
  },
  computed: {
    ...mapGetters(['getPaises', 'getTipoRedes', 'getCargandoAccion', 'getIdioma']),
    textoInicio () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:3rem;color:#4180FF;'
        case 'sm': return 'font-size:3rem;color:#4180FF;'
        case 'md': return 'font-size:4rem;color:#4180FF;'
        case 'lg': return 'font-size:5rem;color:#4180FF;'
        case 'xl': return 'font-size:6rem;color:#4180FF;'
        default: return 'font-size:6rem;color:#4180FF;'
      }
    }
  },
  methods: {
    ...mapMutations(['setCargandoAccion', 'setAlerta', 'setTextoAlerta']),
    ...mapActions(['enviarCorreo']),
    cambioIncluirRed () {
      if (!this.incluirRed) {
        this.iconoRed = null
        this.enlaceRed = null
        this.info.redesSociales = []
      }
    },
    anadirRed () {
      if (this.info.redesSociales.length <= 1) {
        var red = {
          icono: this.iconoRed,
          enlace: this.enlaceRed
        }
        this.info.redesSociales.push(red)
        this.iconoRed = null
        this.enlaceRed = null
      }
    },
    eliminarRed (index) {
      this.info.redesSociales.splice(index, 1)
    },
    async subirImagen (imagen) {
      var upload = await firebase.storage().ref().child('/postulaciones/' + this.info.codigo + '/' + imagen.name).put(imagen)
      var url = await upload.ref.getDownloadURL()
      return url
    },
    async usuarios () {
      await firebase.firestore().collection('postulaciones').where('email', '==', this.info.email).get().then(info => {
        for (let i = 0; i < info.docs.length; i++) {
          this.artistas.push(info.docs[i].data())
        }
        this.postularse()
      })
    },
    async postularse () {
      // VERIFICAR QUE HAY USUARIOS POSTULADOS CON EL CORREO
      if (this.artistas.length > 0) {
        if (this.getIdioma === 'es') {
          this.info.idioma = 'Es'
        } else {
          this.info.idioma = 'En'
        }
        // UPDATE REGISTRO POSTULANTE CUANDO HAYA SIDO RECHAZADO
        if (this.artistas[0].revisado === true && this.artistas[0].aprobado === false) {
          if (this.imagenes.length > 0) {
            this.setCargandoAccion(true)
            var contador = this.imagenes.length
            for (let i = 0; i < this.imagenes.length; i++) {
              const url = await this.subirImagen(this.imagenes[i])
              this.info.imagenes.push(url)
              if (url) {
                contador = contador - 1
                if (contador === 0) {
                  this.info.codigo = this.artistas[0].codigo
                  await firebase.firestore().collection('postulaciones').doc(this.artistas[0].codigo).update(this.info).then(() => {
                    this.setCargandoAccion(false)
                    this.dialog = false
                    this.imagenes = []
                    this.setAlerta()
                    this.setTextoAlerta('Alerta.PostulacionExitosa')
                    this.enviarCorreo({
                      destino: this.info.email,
                      asunto: this.$i18n.t('Formularios.AsuntoPostulado'),
                      texto: this.$i18n.t('Formularios.MensajePostulado', { nombre: this.info.nombre })
                    })
                  })
                  this.artistas = []
                }
              }
            }
            // ELSE DE CONTADOR IMAGENES QUE NO ESTE VACIO O QUE ESTEN LAS 3 IMAGENES
          } else {
            this.setAlerta()
            this.setTextoAlerta('Alerta.AdjuntaImagenes')
          }
          // ELSE CUANDO HAY UN USUARIO PORSTULADO Y REVISADO ESTA FALSE ES DECIR QUE HA AUN NO SE HA REGISTRADO O QUE YA ESTA APROBADO
        } else {
          this.setAlerta()
          this.setTextoAlerta('Alerta.CorreoEnUso')
          // console.log('hola')
          this.artistas = []
        }
        // ELSE CUANDO NO HAY USUARIOS POSTULADOS REGISTRADOS CON ESE CORREO
      } else {
        if (this.imagenes.length > 0) {
          if (this.getIdioma === 'es') {
            this.info.idioma = 'Es'
          } else {
            this.info.idioma = 'En'
          }
          this.setCargandoAccion(true)
          var cont = this.imagenes.length
          for (let i = 0; i < this.imagenes.length; i++) {
            const url = await this.subirImagen(this.imagenes[i])
            this.info.imagenes.push(url)
            if (url) {
              cont = cont - 1
              if (cont === 0) {
                await firebase.firestore().collection('postulaciones').doc(this.info.codigo).set(this.info).then(() => {
                  this.setCargandoAccion(false)
                  this.dialog = false
                  this.imagenes = []
                  this.setAlerta()
                  this.setTextoAlerta('Alerta.PostulacionExitosa')
                  this.enviarCorreo({
                    destino: this.info.email,
                    asunto: this.$i18n.t('Formularios.AsuntoPostulado'),
                    texto: this.$i18n.t('Formularios.MensajePostulado', { nombre: this.info.nombre })
                  })
                })
              }
            }
          }
        } else {
          this.setAlerta()
          this.setTextoAlerta('Alerta.AdjuntaImagenes')
        }
      }
    },
    moverImagen () {
      for (let i = 0; i < this.preImagenes.length; i++) {
        this.imagenes.push(this.preImagenes[i])
        if (i === (this.preImagenes.length - 1)) {
          this.preImagenes = []
        }
      }
    },
    removerImagen (index) {
      this.imagenes.splice(index, 1)
    }
  }
}
</script>

<style>
.pqr, .pqr h3 {
  color: white!important;
}
.pqr li {
  color: white;
  font-family: 'Be Vietnam', sans-serif!important;
  font-size: 24px;
  font-weight: 400;
  padding-top: 10px;
  line-height: 40px;
}
.v-chip {
  margin: 5px;
}
@media (max-width: 600px) {
  .v-dialog.registrarse {
    max-width:80%!important;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .v-dialog.registrarse {
    max-height: 90%!important;
    max-width:70%!important;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .v-dialog.registrarse {
    max-height: 90%!important;
    max-width:60%!important;
  }
}
@media (min-width: 1264px) {
  .v-dialog.registrarse {
    max-height: 80%!important;
    max-width:50%!important;
  }
}
</style>
